import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import { type ReactNode } from "react";

import { isRedundantTitle } from "./store-description";

export function StoreRules({
  title,
  body,
  licenseNotice,
}: {
  readonly title: string;
  readonly body: ReactNode;
  readonly licenseNotice?: {
    readonly text: string;
    readonly href: string;
  } | null;
}) {
  return (
    <div {...stylex.props(styles.stack)}>
      {isRedundantTitle(title) ? null : (
        <p {...stylex.props(styles.eyebrow)}>{title}</p>
      )}
      <div {...stylex.props(styles.prose)}>{body}</div>
      {licenseNotice ? (
        <p {...stylex.props(styles.license)}>
          <a
            href={licenseNotice.href}
            target="_blank"
            rel="noopener noreferrer"
            {...stylex.props(styles.link)}
          >
            {licenseNotice.text}
          </a>
        </p>
      ) : null}
    </div>
  );
}

const styles = stylex.create({
  stack: { display: "flex", flexDirection: "column", gap: spacing.space16 },
  eyebrow: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    lineHeight: "18px",
    color: colors.muted,
  },
  prose: { width: "100%", maxWidth: "68ch" },
  license: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    lineHeight: "18px",
    color: colors.muted,
  },
  link: {
    color: { default: "inherit", ":hover": colors.foreground },
    textDecorationLine: { default: "none", ":hover": "underline" },
    textUnderlineOffset: 3,
    textDecorationColor: colors.borderStrong,
  },
});
